import React from "react"
import { Link } from "gatsby"

import * as headerStyles from "./styles/header.module.css"

const Header = () => {
  return (
    <header className={headerStyles.header}>
      <span>
        <Link to="/">Joshua Söhn</Link>
      </span>
      <span className={headerStyles.years}>
        Designer based in Berlin, Germany
      </span>
      <span className={headerStyles.nav}>
        <Link to="/" activeClassName={headerStyles.active}>
          Work
        </Link>
        <Link to="/catalog" activeClassName={headerStyles.active}>
          Catalog
        </Link>
        <Link to="/profile" activeClassName={headerStyles.active}>
          Profile
        </Link>
      </span>
    </header>
  )
}

export default Header
